import api from './axios.js';

export const contactsApi = {
  list: (params) => api.get('/contacts', { params }),
  tags: () => api.get('/contacts/tags'),
  get: (id) => api.get(`/contacts/${id}`),
  create: (data) => api.post('/contacts', data),
  update: (id, data) => api.put(`/contacts/${id}`, data),
  delete: (id) => api.delete(`/contacts/${id}`),
  setTags: (id, tags) => api.post(`/contacts/${id}/tags`, { tags }),
  setOptOut: (id, isOptedOut) => api.patch(`/contacts/${id}/opt-out`, { isOptedOut }),
  import: (contacts, tag) => api.post('/contacts/import', { contacts, tag }),
  bulkDelete: (ids) => api.post('/contacts/bulk-delete', { ids }),
  bulkSms: (data) => api.post('/contacts/bulk-sms', data),
  export: (params) => api.get('/contacts/export', { params, responseType: 'blob' }),
  optOuts: (params) => api.get('/contacts/opt-outs', { params }),
  exportOptOuts: (params) => api.get('/contacts/opt-outs/export', { params, responseType: 'blob' }),
  timeline: (id) => api.get(`/contacts/${id}/timeline`),
  updateConversation: (id, data) => api.patch(`/contacts/${id}/conversation`, data),
  notes: (id) => api.get(`/contacts/${id}/notes`),
  addNote: (id, body) => api.post(`/contacts/${id}/notes`, { body }),
  deleteNote: (id, noteId) => api.delete(`/contacts/${id}/notes/${noteId}`),
};
